import axios from "axios";
import constants from "../constants";

const {
  GET_ADS, GET_ADS_SUCCESS, GET_ADS_ERROR,
  ADD_AD, ADD_AD_SUCCESS, ADD_AD_ERROR,
  EDIT_AD, EDIT_AD_SUCCESS, EDIT_AD_ERROR,
  DELETE_AD, DELETE_AD_SUCCESS, DELETE_AD_ERROR
} = constants;

const ADD_AD_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/add-ad";
const GET_ADS_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/get-ads";
const EDIT_AD_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/update-ad";
const DELETE_AD_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/delete-ad";

export const getAdsAction = (config) => async (dispatch) => {
  dispatch({ type: GET_ADS })
  await axios.get(GET_ADS_API_END_POINT, config)
    .then((res) => dispatch({ type: GET_ADS_SUCCESS, ads: res?.data?.ads }))
    .catch((error) => dispatch({ type: GET_ADS_ERROR, error }))
}

export const addAdAction = (data, config, callback1, callback2) => async (dispatch) => {
  dispatch({ type: ADD_AD })
  await axios.post(ADD_AD_API_END_POINT, data, config)
    .then((res) => {
      dispatch({ type: ADD_AD_SUCCESS, message: res?.data?.message })
      if (typeof callback1 === 'function') callback1();
      if (typeof callback2 === 'function') callback2();
    })
    .catch((error) => dispatch({ type: ADD_AD_ERROR, error }))
}

export const updateAdAction = (update, config, callback1, callback2) => async (dispatch) => {
  dispatch({ type: EDIT_AD })
  await axios.post(EDIT_AD_API_END_POINT, {update}, config)
    .then((res) => {
      dispatch({ type: EDIT_AD_SUCCESS, message: res?.data?.message })
      if (typeof callback1 === 'function') callback1();
      if (typeof callback2 === 'function') callback2();
    })
    .catch((error) => dispatch({ type: EDIT_AD_ERROR, error }))
}

export const deleteAdAction = (data, config, callback) => async (dispatch) => {
  dispatch({ type: DELETE_AD })
  await axios.post(DELETE_AD_API_END_POINT, data, config)
    .then((res) => {
      dispatch({ type: DELETE_AD_SUCCESS, message: res?.data?.message })
      if (typeof callback === 'function') callback();
    })
    .catch((error) => dispatch({ type: DELETE_AD_ERROR, error }))
}
